import ProductCard from "@/components/products/ProductCard";
import { Heading } from "@/components/ui/heading.jsx";
import { WhenVisible, Link, usePage, Deferred } from "@inertiajs/react";
import { ChevronRight } from "lucide-react";
import { Button } from "~/components/ui/button.jsx";
import ProductPropertyHorizontalFilter from "@/components/products/ProductPropertyHorizontalFilter.jsx";
import HorizontalPriceFilter from "@/components/products/HorizontalPriceFilter.jsx";
import FilterHandler from "@/lib/products/filter";
import { taxon_path } from "@/routes";
import { Skeleton } from "@/components/ui/skeleton";
import TaxonsHorizontalFilter from "./TaxonsHorizontalFilter";
import { allowedProductPropertiesFilters } from "../../lib/utils";

export default function ({ selection, ref }) {
  return (
    <div id={`selection-${selection.taxon.id}`}>
      <div className="flex justify-center items-center py-4 lx:py-8 px-2">
        <Heading size="h3" as="h2" variant="dash" className="text-center">
          {selection.title}
        </Heading>
      </div>
      <div>
        <WhenVisible
          buffer={500}
          fallback={
            <div className="space-x-4 flex">
              <Skeleton className="h-[20px] w-[145px] rounded" />
              <Skeleton className="h-[20px] w-[120px] rounded" />
              <Skeleton className="h-[20px] w-[100px] rounded" />
            </div>
          }
          data={selection.taxon.permalink}
        >
          <Filters taxon={selection.taxon} />
        </WhenVisible>
      </div>
      <div className="grid gap-2 xl:gap-4 grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 ">
        {selection.products.map((product) => {
          return <ProductCard product={product} cover={!!selection.taxon.product_card_type_cover} />;
        })}
      </div>
      <div className="flex justify-center py-8">
        <Button asChild variant="default" color={"pink"} size="xl">
          <Link href={`/t/${selection.link}`}>
            Показать все
            <ChevronRight />
          </Link>
        </Button>
      </div>
    </div>
  );
}
function Filters({ taxon }) {
  const props = usePage().props;
  const filters = props[taxon.permalink];
  const filterHandler = new FilterHandler();

  const product_properties_filters = allowedProductPropertiesFilters(
      taxon,
      filters.product_properties
    );

  const handlePriceChange = (values) => {
    filterHandler.applyPriceFilter(values);
    filterHandler.navigate(taxon_path(taxon.permalink));
  };

  const handleTaxonsChange = (values) => {
    filterHandler.applyTaxonsFilter(values);
    filterHandler.navigate(taxon_path(taxon.permalink));
  };

  return (
    <div className="space-x-4 py-2 flex flex-1 justify-center items-center overflow-y-scroll scrollbar scrollbar-track-gray-50 scrollbar-thumb-gray-100 mb-4">
      <HorizontalPriceFilter onValuesChange={handlePriceChange} />

      {taxon.display_children_taxons_filter && (
        <TaxonsHorizontalFilter
          taxons={taxon.children}
          onValuesChange={handleTaxonsChange}
        />
      )}

      {product_properties_filters.map((productPropertyFilter) => {
        const handelPropertyFilterChange = (values) => {
          const filterKey = `filter[properties][${productPropertyFilter.name}]`;
          filterHandler.applyProductPropertyFilter(filterKey, values);
          filterHandler.navigate(taxon_path(taxon.permalink));
        };

        return (
          <ProductPropertyHorizontalFilter
            key={`filter-${productPropertyFilter.name}`}
            productPropertyFilter={productPropertyFilter}
            onValuesChange={handelPropertyFilterChange}
          />
        );
      })}
    </div>
  );
}
